import {
  DEFAULT_LIMIT,
  DEFAULT_PAGE,
  SEARCH_SORT_DIRECTION_DESC,
} from '@helpers/constants';
import { isEmptyString } from '@helpers/utils';
import {
  SearchParams,
  SearchSortDirection,
  SearchSortField,
  SearchType,
} from './types';

export const getSearchUrl = (searchParams: SearchParams) => {
  let url;

  if (searchParams.searchType === SearchType.BULK_SEARCH) {
    const splitSearchTerm = searchParams.searchTerm
      .split(',')
      .map(term => encodeURIComponent(term.trim()));

    url = `v3/bulksearch/album?searchTerm=${splitSearchTerm.join(
      '&searchTerm=',
    )}`;
  } else {
    url = `v3/search/album?searchTerm=${encodeURIComponent(
      searchParams.searchTerm,
    )}`;
  }

  if (searchParams.feedIds && searchParams.feedIds.length > 0) {
    url = `${url}&feedIds=${searchParams.feedIds.join('&feedIds=')}`;
  }

  if (searchParams.licensorIds && searchParams.licensorIds.length > 0) {
    url = `${url}&licensorIds=${searchParams.licensorIds.join(
      '&licensorIds=',
    )}`;
  }

  const requestedResultLimit =
    searchParams.limit && !isEmptyString(searchParams.limit)
      ? Number(searchParams.limit)
      : Number(DEFAULT_LIMIT);
  const currentPage =
    searchParams.page && !isEmptyString(searchParams.page)
      ? Number(searchParams.page)
      : Number(DEFAULT_PAGE);
  const requestOffset = (currentPage - 1) * requestedResultLimit;
  const searchSortField: SearchSortField =
    searchParams.searchSortField && !isEmptyString(searchParams.searchSortField)
      ? searchParams.searchSortField
      : 'ORIGINAL_RELEASE_DATE';
  const searchSortDirection: SearchSortDirection =
    searchParams.searchSortDirection &&
    !isEmptyString(searchParams.searchSortDirection)
      ? searchParams.searchSortDirection
      : SEARCH_SORT_DIRECTION_DESC;

  url = `${url}&limit=${requestedResultLimit}&offset=${requestOffset}&searchSort.field=${searchSortField}&searchSort.direction=${searchSortDirection}`;

  return url;
};
